document.addEventListener('DOMContentLoaded',()=>{
  document.querySelectorAll('[data-add-to-cart]').forEach(form=>{
    form.addEventListener('submit',async e=>{
      e.preventDefault();
      const btn=form.querySelector('button');
      const old=btn.textContent; btn.textContent='Adding…'; btn.disabled=true;
      try{
        const res=await fetch('/cart/add.js',{method:'POST',headers:{'Accept':'application/json'},body:new FormData(form)});
        if(!res.ok) throw new Error();
        btn.textContent='Added ✓';
        setTimeout(()=>{btn.textContent=old;btn.disabled=false},1200);
        const count=await fetch('/cart.js').then(r=>r.json());
        document.querySelectorAll('.cartCount').forEach(x=>x.textContent=count.item_count);
      }catch(err){btn.textContent='Try again';setTimeout(()=>{btn.textContent=old;btn.disabled=false},1500)}
    });
  });
});

// Cart quantity + / - controls

document.addEventListener('click',(e)=>{
  const btn=e.target.closest('[data-qty-minus],[data-qty-plus]');
  if(!btn) return;
  const wrap=btn.closest('[data-qty-control]');
  const input=wrap && wrap.querySelector('.qtyInput');
  if(!input) return;
  let value=parseInt(input.value,10) || 0;
  if(btn.hasAttribute('data-qty-plus')) value += 1;
  else value = Math.max(0, value - 1);
  input.value=value;
});
